import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect } from "react";
import { trackEvent } from "../../utils/analytics";
import { TermsContent } from "../TermsContent";

interface TermsOfServiceDialogProps {
	open: boolean;
	onClose: () => void;
}

export const TermsOfServiceDialog: React.FC<TermsOfServiceDialogProps> = ({ open, onClose }) => {
	// Track dialog opened event
	useEffect(() => {
		if (open) {
			trackEvent("terms_dialog_opened");
		}
	}, [open]);

	const handleClose = () => {
		trackEvent("terms_dialog_closed");
		onClose();
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth="md"
			fullWidth
			scroll="paper"
			aria-labelledby="terms-of-service-dialog"
			data-testid="terms-of-service-dialog"
			slotProps={{
				paper: {
					sx: {
						borderRadius: "8px",
						boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
						width: "100%",
						maxWidth: "800px",
						height: "auto",
						maxHeight: "80vh",
						display: "flex",
						flexDirection: "column",
					},
				},
			}}
		>
			<DialogTitle
				id="terms-of-service-dialog"
				sx={{
					fontSize: "1.5rem",
					fontWeight: 600,
					color: "#1A1A1A",
					p: 3,
					borderBottom: "1px solid #E1E6EF",
				}}
			>
				In-House Health: User Terms and Conditions
			</DialogTitle>
			<DialogContent
				sx={{
					p: 3,
					overflowY: "auto",
					"&::-webkit-scrollbar": {
						width: "8px",
						height: "8px",
					},
					"&::-webkit-scrollbar-track": {
						backgroundColor: "#f1f1f1",
						borderRadius: "4px",
					},
					"&::-webkit-scrollbar-thumb": {
						backgroundColor: "#c1c1c1",
						borderRadius: "4px",
						"&:hover": {
							backgroundColor: "#a1a1a1",
						},
					},
					scrollbarWidth: "thin",
					scrollbarColor: "#c1c1c1 #f1f1f1",
				}}
				onScroll={(e) => {
					const target = e.target as HTMLDivElement;
					const isBottomReached = target.scrollHeight - target.scrollTop === target.clientHeight;
					if (isBottomReached) {
						trackEvent("terms_dialog_scrolled_to_bottom");
					}
				}}
			>
				<TermsContent />
			</DialogContent>
			<DialogActions
				sx={{
					p: 3,
					borderTop: "1px solid #E1E6EF",
					display: "flex",
					justifyContent: "flex-end",
				}}
			>
				<Button
					onClick={handleClose}
					variant="contained"
					data-testid="terms-of-service-close-button"
					sx={{
						bgcolor: "primary.main",
						color: "white",
						borderRadius: "8px",
						px: 4,
						py: 1,
						textTransform: "none",
						fontWeight: 500,
						"&:hover": {
							bgcolor: "var(--inhouse-primary-dark)",
						},
					}}
				>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};
